// ====================
// components/HeroSection.js
// ====================

import React from 'react';
import birdPfp from '../assets/bird pfp.jpg';
//import { Shield } from 'lucide-react';

const HeroSection = ({ scrollToSection }) => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1>Nicole Amaral</h1>
          <h2>Computer Science & Cybersecurity Student</h2>
          <p>
            Passionate about digital security, privacy and innovative technology solutions. Currently pursuing a Bachelor's in Computer Science with a minor in cybersecurity at Champlain College in Burlington VT.
          </p>
          
          <div className="hero-stats">
            <div className="stat">
              <h3>3.94</h3>
              <p>GPA</p>
            </div>
            <div className="stat">
              <h3>2026</h3>
              <p>Graduation</p>
            </div>
          </div>
          
          <div className="hero-buttons">
            <button onClick={() => scrollToSection('projects')} className="btn-primary">
              View Projects
            </button>
            <button onClick={() => scrollToSection('contact')} className="btn-secondary">
              Contact Me
            </button>
          </div>
        </div>
        
        <div className="hero-visual">
          <img src={birdPfp} alt="Bird Profile" className="hero-bird-img" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;